import { apiCall } from './authServices';

const handleApiError = (error) => {
  let errorMessage = 'An error occurred';
  
  if (error.response?.data?.error) {
    errorMessage = error.response.data.error;
  } else if (error.response?.data?.message) {
    errorMessage = error.response.data.message;
  } else if (error.message) {
    errorMessage = error.message;
  }
  
  return errorMessage;
};

export const getAllUsers = async (payload) => {
  try {
    const response = await apiCall({
      endpoint: 'api/users/get-user-list',
      method: 'POST',
      payload: payload
    });
    
    return response;
  } catch (error) {
    console.error('Get users error:', error);
    throw new Error(handleApiError(error));
  }
};

export const uploadUserFile = async (userData) => {
  try {
    const response = await apiCall({
      endpoint: 'api/users/upload',
      method: 'POST',
      payload: userData,
    });
    
    if (response?.success) {
      return response;
    }
    throw new Error(response?.error || response?.message || 'Upload failed');
  } catch (error) {
    console.error('Upload service error:', error);
    throw error;
  }
};


export { handleApiError };
